import { render, staticRenderFns } from "./CapituloSietePage.vue?vue&type=template&id=4153a599"
import script from "./CapituloSietePage.js?v=1?vue&type=script&lang=js&external"
export * from "./CapituloSietePage.js?v=1?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports